export enum EP360Tabs {
  JbpDeviceInfo = '1',
  JbpMarketInfo = '2',
  JbpHistoricalResults = '3',
  JbpAssortment = '4',
  JbpCompensationScheme = '5',
  JbpActionPlans = '6',
  JbpCommitment = '7',
  JbpActionPlansDistributor = '8',
  JbpMasterDealer = '9',
  JbpShareOfBusiness = '10',
  JbpScope = '11',
  JbpAmplifyEligibility = '12',
  JbpSolutions = '13',
  JbpInventoryManagement = '14',
  JbpCreditStatusInfo = '15',
  JbpSwotAnalysis = '16',
  JbpDataInsight = '17',
  JbpAmplifyImpact = '18',
  JbpGraphs = '19',
  JbpPlanning = '20',
  JbpInitiativesActions = '21',
  JbpTopDeals = '22',
  JbpBasicInfo = '23',
}
